// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27%23475569%27 viewBox=%270 0 256 256%27%3E%3Cpath d=%27M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SocialGroupsSection.css */
.sg-groups-section {
  padding: 0;
  background: transparent;
  min-height: 500px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* Заголовок */
.sg-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.sg-header-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.header-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  height: 48px;
}

.header-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.header-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.sg-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}

.sg-section-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Информационная иконка */
.info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.info-icon-text {
  font-weight: 700;
  font-size: 16px;
  color: #002FA7;
}

.info-icon-btn:hover .info-tooltip,
.info-icon-btn:focus-within .info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
}

.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(10px);
  background: white;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 20px;
  width: 320px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.info-tooltip-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}

/* Кнопка обновления */
.pc-refresh-icon {
  width: 22px;
  height: 22px;
  transition: transform 0.3s ease;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Предупреждения и ошибки */
.sg-cache-warning,
.sg-error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  animation: slideIn 0.3s ease;
}

.sg-cache-warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #fcd34d;
  color: #92400e;
}

.sg-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #fca5a5;
  color: #991b1b;
}

.sg-cache-warning img,
.sg-error-message img {
  width: 20px;
  height: 20px;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Улучшенная панель управления */
.sg-control-panel-enhanced {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Поиск и переключатель вида */
.sg-controls-top-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: center;
}

.sg-search-box-enhanced {
  position: relative;
  flex: 1 1;
}

.sg-search-input-enhanced {
  width: 100%;
  padding: 14px 20px 14px 48px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
  font-weight: 500;
}

.sg-search-input-enhanced:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.sg-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.sg-search-icon img {
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

.sg-view-toggle {
  display: flex;
  background: #f8fafc;
  border-radius: 12px;
  padding: 4px;
  border: 2px solid #e2e8f0;
  gap: 4px;
  flex-shrink: 0;
}

.sg-view-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.sg-view-btn:hover {
  background: #e2e8f0;
}

.sg-view-btn.sg-view-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sg-view-btn img {
  width: 18px;
  height: 18px;
  opacity: 0.7;
}

.sg-view-btn.sg-view-active img {
  opacity: 1;
}

/* Фильтры */
.sg-controls-middle-row {
  width: 100%;
}

.sg-filters-grid {
  display: grid;
  grid-template-columns: minmax(140px, auto) 1fr minmax(200px, auto);
  gap: 20px;
  align-items: start;
}

.sg-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sg-filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sg-filter-select-enhanced {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-size: 14px;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding-right: 44px;
}

.sg-filter-select-enhanced:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

/* Специальные стили для фильтра по курсу */
.sg-course-filter {
  min-width: 140px;
}

.sg-course-select {
  min-width: 140px;
  max-width: 180px;
}

/* Стили для фильтра по специальности (самый большой) */
.sg-specialty-filter {
  flex: 1 1;
  min-width: 0;
}

.sg-specialty-select {
  width: 100%;
  min-width: 300px;
  max-width: 100%;
}

/* Стили для фильтра по категории */
.sg-category-filter {
  min-width: 200px;
}

.sg-category-select {
  min-width: 200px;
  max-width: 280px;
}

/* Сортировка - двухколоночный макет */
.sg-controls-bottom-row {
  width: 100%;
  padding-top: 20px;
  border-top: 2px solid #f1f5f9;
}

.sg-sort-controls-enhanced {
  width: 100%;
}

.sg-sort-group {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.sg-sort-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.sg-sort-select {
  min-width: 200px;
  max-width: 300px;
}

/* Сортировка - плавная анимация */
.sg-sort-order-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.sg-sort-order-btn:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.sg-sort-order-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.1);
}

/* Анимация иконки */
.sg-sort-order-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

/* Плавное вращение иконки при изменении направления */
.sg-sort-order-btn:hover .sg-sort-order-icon {
  transform: scale(1.1);
}

/* Анимация переключения между asc и desc */
@keyframes flipIn {
  0% {
    opacity: 0;
    transform: rotateX(-90deg) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: rotateX(0) scale(1);
  }
}

@keyframes flipOut {
  0% {
    opacity: 1;
    transform: rotateX(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: rotateX(90deg) scale(0.8);
  }
}

.sg-sort-order-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.sg-sort-order-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
}

.sg-sort-order-btn:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
}

/* Карточки статистики */
.sg-stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.sg-stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sg-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #002FA7;
}

/* Карточки статистики */
.sg-stat-icon {
  width: 50px; 
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
}

.sg-stat-icon img {
  width: 27px;
  height: 27px;
  filter: brightness(0) invert(1);
}

.sg-stat-info h3 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #002FA7;
  line-height: 1;
}

.sg-stat-info p {
  margin: 8px 0 0 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

/* Контент с группами */
.sg-content-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.sg-stats-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}

.sg-stats-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sg-groups-count {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64748b;
  background: #f8fafc;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.sg-groups-count:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.sg-groups-count img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  opacity: 0.7;
}

.sg-groups-count span {
  color: #002FA7;
  font-weight: 600;
}

.sg-groups-count strong {
  font-weight: 700;
  color: #002FA7;
}

/* Состояния загрузки и ошибок */
.sg-loading {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.sg-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 47, 167, 0.1);
  border-left: 3px solid #002FA7;
  border-radius: 50%;
  animation: sg-spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes sg-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.sg-empty-state {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.sg-empty-state img {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.sg-empty-subtitle {
  margin-top: 8px;
  color: #94a3b8;
  font-size: 14px;
}

/* Карточки групп */
.sg-groups-cards-container {
  max-width: 100%;
}

.sg-groups-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.sg-group-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  overflow: hidden;
}

.sg-group-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);
  border-color: #002FA7;
}

.sg-group-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);
}

/* Верхняя часть карточки */
.sg-card-top {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sg-card-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sg-card-group-number {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sg-group-number-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.sg-group-number-value {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
}

.sg-card-course {
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.sg-course-label {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
}

.sg-card-specialty h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Основная информация */
.sg-card-main-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.sg-card-students,
.sg-card-categories {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.sg-students-label,
.sg-categories-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.sg-students-value,
.sg-categories-value {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
}

/* Показатели */
.sg-card-metrics {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sg-card-metric {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sg-metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sg-metric-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.sg-metric-value {
  font-size: 16px;
  font-weight: 700;
  color: #002FA7;
}

.sg-metric-progress {
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
}

.sg-metric-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

/* Ответственные */
.sg-card-responsible {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.sg-responsible-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sg-responsible-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.sg-responsible-value {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Список групп */
.sg-groups-list-container {
  max-width: 100%;
}

.sg-groups-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sg-group-list-item {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.sg-group-list-item:hover {
  background: #f8fafc;
  border-color: #002FA7;
  transform: translateX(4px);
}

.sg-group-list-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #002FA7;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sg-group-list-item:hover::before {
  opacity: 1;
}

.sg-list-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sg-list-header {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.sg-list-group-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sg-list-group-number {
  font-size: 18px;
  font-weight: 700;
  color: #002FA7;
}

.sg-list-course-badge {
  background: #002FA7;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.sg-list-specialty {
  font-size: 15px;
  color: #1e293b;
  font-weight: 500;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sg-list-details {
  display: flex;
  gap: 20px;
  align-items: center;
}

.sg-list-detail {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.sg-detail-label {
  color: #64748b;
  font-weight: 500;
}

.sg-detail-value {
  color: #002FA7;
  font-weight: 600;
}

.sg-list-metrics {
  display: flex;
  gap: 24px;
  min-width: 320px;
}

.sg-list-metric {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sg-list-metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.sg-list-metric-header span:first-child {
  color: #64748b;
  font-weight: 500;
}

.sg-list-metric-header span:last-child {
  color: #002FA7;
  font-weight: 700;
  font-size: 14px;
}

.sg-list-progress {
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
}

.sg-list-progress-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}

/* Модальные окна */
.pc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.pc-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: modal-appear 0.2s ease-out;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.pc-modal-lg {
  max-width: 1000px;
  width: 95%;
}

.pc-modal-xl {
  max-width: 1200px;
  width: 98%;
}

.pc-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 12px 12px 0 0;
  color: white;
}

.pc-modal-header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.pc-modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc-modal-icon img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.pc-group-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.pc-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.pc-modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  opacity: 0.9;
  font-weight: 400;
}

.pc-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 4px 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.pc-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.pc-modal-content {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.pc-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
}

.pc-btn-secondary {
  padding: 12px 24px;
  background: white;
  color: #374151;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pc-btn-secondary:hover:not(:disabled) {
  border-color: #002FA7;
  color: #002FA7;
}

.pc-btn-secondary:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

/* Детальная информация о группе */
.sg-group-detail-info {
  max-height: none;
  overflow-y: visible;
  padding-right: 0;
}

.sg-group-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.sg-responsible-section,
.sg-performance-section {
  min-width: 0;
}

.sg-responsible-cards,
.sg-performance-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sg-responsible-card,
.sg-performance-card {
  padding: 16px;
}

.sg-responsible-section h4,
.sg-performance-section h4 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sg-performance-icon{
  width: 25px;
  height: 25px;
}

.sg-responsible-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sg-responsible-card {
  background: white;
  padding: 20px;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.sg-responsible-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);
  border-color: #002FA7;
}

.sg-responsible-info h5 {
  margin: 0 0 4px 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

.sg-responsible-name {
  margin: 0 0 4px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
}

.sg-responsible-role {
  margin: 0;
  color: #002FA7;
  font-size: 14px;
  font-weight: 500;
}

/* Показатели */
.sg-performance-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sg-performance-card {
  background: white;
  padding: 20px;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.sg-performance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);
  border-color: #002FA7;
}

.sg-performance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.sg-performance-header span:first-child {
  font-size: 16px;
  color: #1e293b;
  font-weight: 600;
}

.sg-performance-value {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
}

.sg-progress-bar-lg {
  height: 10px;
  background: #f1f5f9;
  border-radius: 5px;
  overflow: hidden;
}

.sg-progress-fill-lg {
  height: 100%;
  border-radius: 5px;
  transition: width 0.6s ease;
}

/* Категории */
.sg-group-section {
  margin-bottom: 32px;
}

.sg-section-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.sg-categories-detailed {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 4px;
}

.sg-category-detailed {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 20px;
  border: 2px solid #e2e8f0;
  background: white;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
          user-select: none;
}

.sg-category-detailed:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.12);
  border-color: #cbd5e1;
}

.sg-category-detailed.sg-category-selected {
  border-color: #002FA7;
  background: #f0f4ff;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.15);
}

.sg-category-detailed.sg-category-selected .sg-category-name {
  color: #002FA7;
  font-weight: 600;
}

.sg-category-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sg-category-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.sg-category-check {
  color: white;
  font-weight: bold;
  font-size: 12px;
  z-index: 1;
}

.sg-category-name {
  flex: 1 1;
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
}

.sg-category-count {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
}

.sg-progress-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sg-progress-bar {
  flex: 1 1;
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
}

.sg-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.sg-percent {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
  min-width: 40px;
}

/* Студенты */
.sg-students-list-compact {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sg-student-card-compact {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.sg-student-card-compact:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.sg-student-card-border {
  padding: 16px;
}

.sg-student-main-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 16px;
}

.sg-student-basic {
  flex: 1 1;
  min-width: 0;
}

.sg-student-basic h5 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.sg-student-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
}

.sg-student-divider {
  opacity: 0.5;
}

.sg-group-section .sg-search-box-enhanced {
  margin-bottom: 16px;
}

.sg-student-actions-compact {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sg-risk-label-compact {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 70px;
  text-align: center;
}

.sg-risk-high {
  background: #ef4444;
}

.sg-risk-medium {
  background: #f59e0b;
}

.sg-risk-low {
  background: #10b981;
}

.sg-toggle-details-compact {
  background: none;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.sg-toggle-details-compact:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
}

.sg-student-categories-compact {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}

.sg-student-category-compact {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  cursor: pointer;
}

.sg-student-category-compact.sg-student-category-selected {
  position: relative;
  border: 2px solid white !important;
  box-shadow: 0 0 0 2px #002FA7 !important;
}

.sg-student-details-compact {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sg-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.sg-detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sg-detail-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.sg-detail-value {
  font-size: 13px;
  color: #1e293b;
  line-height: 1.4;
}

.sg-clear-filter-btn {
  padding: 6px 12px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.sg-clear-filter-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

/* Статистика */
.sg-stats-overview {
  max-height: none;
  overflow-y: visible;
  padding-right: 0;
}

.sg-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.sg-stat-card-lg {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.sg-stat-card-lg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);
}

.sg-stat-card-lg:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);
  border-color: #002FA7;
}

.sg-stat-icon-lg {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  flex-shrink: 0;
}

.sg-stat-icon-lg img {
  width: 28px;
  height: 28px;
  filter: brightness(0) invert(1);
}

.sg-stat-info-lg h3 {
  margin: 0;
  font-size: 36px;
  font-weight: 700;
  color: #002FA7;
  line-height: 1;
}

.sg-stat-info-lg p {
  margin: 8px 0 0 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

.sg-stats-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
}

.sg-stats-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.sg-groups-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.sg-groups-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
}

.sg-stats-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}

.sg-stats-section-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Статистика - графики и диаграммы */
.sg-key-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.sg-key-metric {
  background: white;
  padding: 20px;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.stat-chart {
  background: #f8fafc;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-top: 12px;
}

.stat-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.stat-chart-title {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.stat-chart-value {
  font-size: 18px;
  font-weight: 700;
  color: #002FA7;
}

.stat-chart-bar {
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.stat-chart-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.6s ease;
}

.sg-charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
}

.sg-chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.line-chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.line-chart-title {
  margin: 0 0 20px 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.line-chart-wrapper {
  height: 200px;
  margin-bottom: 20px;
}

.line-chart {
  width: 100%;
  height: 100%;
}

.line-chart-labels {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.line-chart-label {
  text-align: center;
  flex: 1 1;
}

.line-chart-label span:first-child {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.line-chart-value {
  font-size: 14px;
  font-weight: 700;
  color: #002FA7;
}

/* Круговая диаграмма */
.pie-chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  max-width: auto;
  margin: 0 auto;
}

.pie-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pie-chart-title {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pie-chart-total {
  text-align: right;
}

.pie-total-value {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
}

.pie-total-label {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

.pie-chart-wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto 24px;
}

.pie-chart {
  width: 100%;
  height: 100%;
}

.pie-chart-legend {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 8px;
  margin-top: 20px;
}

.pie-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
}

.pie-legend-color {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}

.pie-legend-label {
  flex: 1 1;
  color: #334155;
  font-weight: 500;
}

.pie-legend-value {
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

/* Детальная статистика по курсам */
.sg-courses-detailed {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.sg-course-detailed {
  background: white;
  padding: 20px;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.sg-course-detailed:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);
  border-color: #002FA7;
}

.sg-course-detailed-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.sg-course-title h5 {
  margin: 0 0 4px 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 700;
}

.sg-course-subtitle {
  font-size: 12px;
  color: #64748b;
}

.sg-course-coverage {
  text-align: right;
}

.sg-course-coverage span:first-child {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.sg-coverage-value {
  font-size: 20px;
  font-weight: 700;
  color: #1A4FBF;
}

.sg-course-metrics {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sg-course-metric {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sg-course-metric span:first-child {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

/* Адаптивность */
@media (max-width: 1200px) {
  .sg-filters-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  .sg-course-filter {
    grid-column: span 1;
  }
  
  .sg-specialty-filter {
    grid-column: span 2;
  }
  
  .sg-category-filter {
    grid-column: span 2;
  }
  
  .sg-group-details-grid {
    grid-template-columns: 1fr;
  }
  
  .sg-groups-cards {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
  
  .sg-charts-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1024px) {
  .sg-controls-top-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .sg-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .sg-sort-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .sg-sort-buttons {
    margin-left: 0;
    justify-content: flex-start;
  }
  
  .sg-list-metrics {
    min-width: 250px;
  }
  
  .sg-key-metrics-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .sg-cabinet-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .sg-header-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .sg-control-panel-enhanced {
    padding: 16px;
  }
  
  .sg-filters-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .sg-specialty-filter,
  .sg-category-filter {
    grid-column: span 1;
  }
  
  .sg-stats-cards,
  .sg-stats-grid {
    grid-template-columns: 1fr;
  }
  
  .sg-section-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .sg-section-header h3 {
    font-size: 18px;
  }
  
  .sg-groups-count {
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .sg-group-card {
    padding: 16px;
  }
  
  .sg-card-main-info {
    padding: 12px;
    gap: 12px;
  }
  
  .sg-students-value,
  .sg-categories-value {
    font-size: 18px;
  }
  
  .sg-card-responsible {
    gap: 8px;
  }
  
  .sg-group-list-item {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  
  .sg-list-main {
    order: 1;
  }
  
  .sg-list-metrics {
    order: 2;
    min-width: 100%;
    flex-direction: column;
    gap: 12px;
  }
  
  .sg-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .sg-list-details {
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .sg-sort-buttons {
    flex-direction: column;
  }
  
  .sg-view-toggle {
    width: 100%;
    justify-content: center;
  }
  
  .pc-modal {
    width: 90%;
  }
  
  .pc-modal-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .pc-modal-icon {
    align-self: flex-start;
  }
  
  .sg-group-main-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .sg-group-number-card {
    align-self: center;
  }
  
  .sg-group-stats-card {
    grid-template-columns: 1fr;
    min-width: auto;
  }
  
  .sg-stat-value {
    font-size: 24px;
  }
  
  .sg-student-main-info {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .sg-student-actions-compact {
    width: 100%;
    justify-content: space-between;
  }
  
  .sg-courses-detailed {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .sg-groups-cards {
    grid-template-columns: 1fr;
  }
  
  .sg-card-group-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .sg-card-course {
    align-self: flex-start;
  }
  
  .sg-card-main-info {
    grid-template-columns: 1fr;
  }
  
  .sg-card-responsible {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .sg-view-btn span {
    display: none;
  }
  
  .sg-view-btn {
    padding: 10px;
    justify-content: center;
  }
  
  .sg-sort-order-btn span {
    display: none;
  }
  
  .sg-sort-order-btn {
    padding: 10px;
    justify-content: center;
  }
  
  .sg-sort-buttons {
    flex-direction: row;
    justify-content: space-between;
  }
  
  .sg-student-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .sg-student-divider {
    display: none;
  }
  
  .sg-student-actions-compact {
    flex-direction: column;
    align-items: stretch;
  }
  
  .sg-toggle-details-compact {
    width: 100%;
  }
  
  .sg-filter-select-enhanced {
    font-size: 16px;
  }
  
  .pie-chart-legend {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/social-components/SocialGroupsSection.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,yDAA4S;EAC5S,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qFAAqF;EACrF,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;EAClD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* SocialGroupsSection.css */\n.sg-groups-section {\n  padding: 0;\n  background: transparent;\n  min-height: 500px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n/* Заголовок */\n.sg-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.sg-header-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.header-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  height: 48px;\n}\n\n.header-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.header-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.sg-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.sg-section-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Информационная иконка */\n.info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.info-icon-text {\n  font-weight: 700;\n  font-size: 16px;\n  color: #002FA7;\n}\n\n.info-icon-btn:hover .info-tooltip,\n.info-icon-btn:focus-within .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(10px);\n  background: white;\n  border: 2px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 320px;\n  max-width: calc(100vw - 40px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.info-tooltip-content {\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* Кнопка обновления */\n.pc-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s ease;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Предупреждения и ошибки */\n.sg-cache-warning,\n.sg-error-message {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  animation: slideIn 0.3s ease;\n}\n\n.sg-cache-warning {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 2px solid #fcd34d;\n  color: #92400e;\n}\n\n.sg-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border: 2px solid #fca5a5;\n  color: #991b1b;\n}\n\n.sg-cache-warning img,\n.sg-error-message img {\n  width: 20px;\n  height: 20px;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Улучшенная панель управления */\n.sg-control-panel-enhanced {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Поиск и переключатель вида */\n.sg-controls-top-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 24px;\n  align-items: center;\n}\n\n.sg-search-box-enhanced {\n  position: relative;\n  flex: 1;\n}\n\n.sg-search-input-enhanced {\n  width: 100%;\n  padding: 14px 20px 14px 48px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n  font-weight: 500;\n}\n\n.sg-search-input-enhanced:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.sg-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  pointer-events: none;\n}\n\n.sg-search-icon img {\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n}\n\n.sg-view-toggle {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 4px;\n  border: 2px solid #e2e8f0;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.sg-view-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.sg-view-btn:hover {\n  background: #e2e8f0;\n}\n\n.sg-view-btn.sg-view-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sg-view-btn img {\n  width: 18px;\n  height: 18px;\n  opacity: 0.7;\n}\n\n.sg-view-btn.sg-view-active img {\n  opacity: 1;\n}\n\n/* Фильтры */\n.sg-controls-middle-row {\n  width: 100%;\n}\n\n.sg-filters-grid {\n  display: grid;\n  grid-template-columns: minmax(140px, auto) 1fr minmax(200px, auto);\n  gap: 20px;\n  align-items: start;\n}\n\n.sg-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sg-filter-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sg-filter-select-enhanced {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  background: white;\n  font-size: 14px;\n  color: #1e293b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23475569' viewBox='0 0 256 256'%3E%3Cpath d='M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 16px;\n  padding-right: 44px;\n}\n\n.sg-filter-select-enhanced:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n/* Специальные стили для фильтра по курсу */\n.sg-course-filter {\n  min-width: 140px;\n}\n\n.sg-course-select {\n  min-width: 140px;\n  max-width: 180px;\n}\n\n/* Стили для фильтра по специальности (самый большой) */\n.sg-specialty-filter {\n  flex: 1;\n  min-width: 0;\n}\n\n.sg-specialty-select {\n  width: 100%;\n  min-width: 300px;\n  max-width: 100%;\n}\n\n/* Стили для фильтра по категории */\n.sg-category-filter {\n  min-width: 200px;\n}\n\n.sg-category-select {\n  min-width: 200px;\n  max-width: 280px;\n}\n\n/* Сортировка - двухколоночный макет */\n.sg-controls-bottom-row {\n  width: 100%;\n  padding-top: 20px;\n  border-top: 2px solid #f1f5f9;\n}\n\n.sg-sort-controls-enhanced {\n  width: 100%;\n}\n\n.sg-sort-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.sg-sort-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.sg-sort-select {\n  min-width: 200px;\n  max-width: 300px;\n}\n\n/* Сортировка - плавная анимация */\n.sg-sort-order-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n}\n\n.sg-sort-order-btn:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.sg-sort-order-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.1);\n}\n\n/* Анимация иконки */\n.sg-sort-order-icon {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  transform-origin: center;\n}\n\n/* Плавное вращение иконки при изменении направления */\n.sg-sort-order-btn:hover .sg-sort-order-icon {\n  transform: scale(1.1);\n}\n\n/* Анимация переключения между asc и desc */\n@keyframes flipIn {\n  0% {\n    opacity: 0;\n    transform: rotateX(-90deg) scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: rotateX(0) scale(1);\n  }\n}\n\n@keyframes flipOut {\n  0% {\n    opacity: 1;\n    transform: rotateX(0) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: rotateX(90deg) scale(0.8);\n  }\n}\n\n.sg-sort-order-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.sg-sort-order-icon {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n}\n\n.sg-sort-order-btn:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n/* Карточки статистики */\n.sg-stats-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.sg-stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sg-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: #002FA7;\n}\n\n/* Карточки статистики */\n.sg-stat-icon {\n  width: 50px; \n  height: 50px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n}\n\n.sg-stat-icon img {\n  width: 27px;\n  height: 27px;\n  filter: brightness(0) invert(1);\n}\n\n.sg-stat-info h3 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: #002FA7;\n  line-height: 1;\n}\n\n.sg-stat-info p {\n  margin: 8px 0 0 0;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Контент с группами */\n.sg-content-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.sg-stats-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.sg-stats-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sg-groups-count {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #64748b;\n  background: #f8fafc;\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.sg-groups-count:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.sg-groups-count img {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  opacity: 0.7;\n}\n\n.sg-groups-count span {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n.sg-groups-count strong {\n  font-weight: 700;\n  color: #002FA7;\n}\n\n/* Состояния загрузки и ошибок */\n.sg-loading {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.sg-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 47, 167, 0.1);\n  border-left: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: sg-spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes sg-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.sg-empty-state {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.sg-empty-state img {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n.sg-empty-subtitle {\n  margin-top: 8px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n/* Карточки групп */\n.sg-groups-cards-container {\n  max-width: 100%;\n}\n\n.sg-groups-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.sg-group-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.sg-group-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);\n  border-color: #002FA7;\n}\n\n.sg-group-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);\n}\n\n/* Верхняя часть карточки */\n.sg-card-top {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sg-card-group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sg-card-group-number {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sg-group-number-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-group-number-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.sg-card-course {\n  background: #f1f5f9;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.sg-course-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.sg-card-specialty h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Основная информация */\n.sg-card-main-info {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.sg-card-students,\n.sg-card-categories {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.sg-students-label,\n.sg-categories-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-students-value,\n.sg-categories-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n/* Показатели */\n.sg-card-metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sg-card-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sg-metric-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sg-metric-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-metric-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.sg-metric-progress {\n  height: 6px;\n  background: #f1f5f9;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.sg-metric-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n/* Ответственные */\n.sg-card-responsible {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.sg-responsible-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sg-responsible-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-responsible-value {\n  font-size: 14px;\n  color: #1e293b;\n  font-weight: 500;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Список групп */\n.sg-groups-list-container {\n  max-width: 100%;\n}\n\n.sg-groups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sg-group-list-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.sg-group-list-item:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  transform: translateX(4px);\n}\n\n.sg-group-list-item::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: #002FA7;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.sg-group-list-item:hover::before {\n  opacity: 1;\n}\n\n.sg-list-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sg-list-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.sg-list-group-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sg-list-group-number {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.sg-list-course-badge {\n  background: #002FA7;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.sg-list-specialty {\n  font-size: 15px;\n  color: #1e293b;\n  font-weight: 500;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sg-list-details {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.sg-list-detail {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.sg-detail-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-detail-value {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n.sg-list-metrics {\n  display: flex;\n  gap: 24px;\n  min-width: 320px;\n}\n\n.sg-list-metric {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sg-list-metric-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.sg-list-metric-header span:first-child {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-list-metric-header span:last-child {\n  color: #002FA7;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.sg-list-progress {\n  height: 4px;\n  background: #f1f5f9;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.sg-list-progress-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n/* Модальные окна */\n.pc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.pc-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  animation: modal-appear 0.2s ease-out;\n}\n\n@keyframes modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.pc-modal-lg {\n  max-width: 1000px;\n  width: 95%;\n}\n\n.pc-modal-xl {\n  max-width: 1200px;\n  width: 98%;\n}\n\n.pc-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 12px 12px 0 0;\n  color: white;\n}\n\n.pc-modal-header-content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.pc-modal-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pc-modal-icon img {\n  width: 24px;\n  height: 24px;\n  filter: brightness(0) invert(1);\n}\n\n.pc-group-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.pc-modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n}\n\n.pc-modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  opacity: 0.9;\n  font-weight: 400;\n}\n\n.pc-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  padding: 4px 8px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.pc-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.pc-modal-content {\n  padding: 24px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.pc-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.pc-btn-secondary {\n  padding: 12px 24px;\n  background: white;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pc-btn-secondary:hover:not(:disabled) {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.pc-btn-secondary:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Детальная информация о группе */\n.sg-group-detail-info {\n  max-height: none;\n  overflow-y: visible;\n  padding-right: 0;\n}\n\n.sg-group-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.sg-responsible-section,\n.sg-performance-section {\n  min-width: 0;\n}\n\n.sg-responsible-cards,\n.sg-performance-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sg-responsible-card,\n.sg-performance-card {\n  padding: 16px;\n}\n\n.sg-responsible-section h4,\n.sg-performance-section h4 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sg-performance-icon{\n  width: 25px;\n  height: 25px;\n}\n\n.sg-responsible-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sg-responsible-card {\n  background: white;\n  padding: 20px;\n  border-radius: 16px;\n  border: 2px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: all 0.3s ease;\n}\n\n.sg-responsible-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);\n  border-color: #002FA7;\n}\n\n.sg-responsible-info h5 {\n  margin: 0 0 4px 0;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.sg-responsible-name {\n  margin: 0 0 4px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.sg-responsible-role {\n  margin: 0;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Показатели */\n.sg-performance-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.sg-performance-card {\n  background: white;\n  padding: 20px;\n  border-radius: 16px;\n  border: 2px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.sg-performance-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);\n  border-color: #002FA7;\n}\n\n.sg-performance-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.sg-performance-header span:first-child {\n  font-size: 16px;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.sg-performance-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.sg-progress-bar-lg {\n  height: 10px;\n  background: #f1f5f9;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.sg-progress-fill-lg {\n  height: 100%;\n  border-radius: 5px;\n  transition: width 0.6s ease;\n}\n\n/* Категории */\n.sg-group-section {\n  margin-bottom: 32px;\n}\n\n.sg-section-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.sg-categories-detailed {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 4px;\n}\n\n.sg-category-detailed {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n}\n\n.sg-category-detailed:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.12);\n  border-color: #cbd5e1;\n}\n\n.sg-category-detailed.sg-category-selected {\n  border-color: #002FA7;\n  background: #f0f4ff;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.15);\n}\n\n.sg-category-detailed.sg-category-selected .sg-category-name {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n.sg-category-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sg-category-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n}\n\n.sg-category-check {\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  z-index: 1;\n}\n\n.sg-category-name {\n  flex: 1;\n  font-size: 14px;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.sg-category-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.sg-progress-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sg-progress-bar {\n  flex: 1;\n  height: 6px;\n  background: #f1f5f9;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.sg-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.sg-percent {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n  min-width: 40px;\n}\n\n/* Студенты */\n.sg-students-list-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sg-student-card-compact {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n}\n\n.sg-student-card-compact:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.sg-student-card-border {\n  padding: 16px;\n}\n\n.sg-student-main-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  gap: 16px;\n}\n\n.sg-student-basic {\n  flex: 1;\n  min-width: 0;\n}\n\n.sg-student-basic h5 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.sg-student-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.sg-student-divider {\n  opacity: 0.5;\n}\n\n.sg-group-section .sg-search-box-enhanced {\n  margin-bottom: 16px;\n}\n\n.sg-student-actions-compact {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sg-risk-label-compact {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  min-width: 70px;\n  text-align: center;\n}\n\n.sg-risk-high {\n  background: #ef4444;\n}\n\n.sg-risk-medium {\n  background: #f59e0b;\n}\n\n.sg-risk-low {\n  background: #10b981;\n}\n\n.sg-toggle-details-compact {\n  background: none;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 6px 12px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.sg-toggle-details-compact:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.sg-student-categories-compact {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.sg-student-category-compact {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n}\n\n.sg-student-category-compact.sg-student-category-selected {\n  position: relative;\n  border: 2px solid white !important;\n  box-shadow: 0 0 0 2px #002FA7 !important;\n}\n\n.sg-student-details-compact {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.sg-details-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n.sg-detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sg-detail-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.sg-detail-value {\n  font-size: 13px;\n  color: #1e293b;\n  line-height: 1.4;\n}\n\n.sg-clear-filter-btn {\n  padding: 6px 12px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.sg-clear-filter-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n/* Статистика */\n.sg-stats-overview {\n  max-height: none;\n  overflow-y: visible;\n  padding-right: 0;\n}\n\n.sg-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.sg-stat-card-lg {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border: 2px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: hidden;\n}\n\n.sg-stat-card-lg::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);\n}\n\n.sg-stat-card-lg:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);\n  border-color: #002FA7;\n}\n\n.sg-stat-icon-lg {\n  width: 60px;\n  height: 60px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  flex-shrink: 0;\n}\n\n.sg-stat-icon-lg img {\n  width: 28px;\n  height: 28px;\n  filter: brightness(0) invert(1);\n}\n\n.sg-stat-info-lg h3 {\n  margin: 0;\n  font-size: 36px;\n  font-weight: 700;\n  color: #002FA7;\n  line-height: 1;\n}\n\n.sg-stat-info-lg p {\n  margin: 8px 0 0 0;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.sg-stats-section {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.sg-stats-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.sg-groups-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.sg-groups-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.sg-stats-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.sg-stats-section-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Статистика - графики и диаграммы */\n.sg-key-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n.sg-key-metric {\n  background: white;\n  padding: 20px;\n  border-radius: 16px;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.stat-chart {\n  background: #f8fafc;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  margin-top: 12px;\n}\n\n.stat-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.stat-chart-title {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.stat-chart-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.stat-chart-bar {\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.stat-chart-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.6s ease;\n}\n\n.sg-charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 24px;\n}\n\n.sg-chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.line-chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.line-chart-title {\n  margin: 0 0 20px 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.line-chart-wrapper {\n  height: 200px;\n  margin-bottom: 20px;\n}\n\n.line-chart {\n  width: 100%;\n  height: 100%;\n}\n\n.line-chart-labels {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.line-chart-label {\n  text-align: center;\n  flex: 1;\n}\n\n.line-chart-label span:first-child {\n  display: block;\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.line-chart-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n/* Круговая диаграмма */\n.pie-chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  max-width: auto;\n  margin: 0 auto;\n}\n\n.pie-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.pie-chart-title {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pie-chart-total {\n  text-align: right;\n}\n\n.pie-total-value {\n  display: block;\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.pie-total-label {\n  display: block;\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.pie-chart-wrapper {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 0 auto 24px;\n}\n\n.pie-chart {\n  width: 100%;\n  height: 100%;\n}\n\n.pie-chart-legend {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.pie-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  font-size: 13px;\n}\n\n.pie-legend-color {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.pie-legend-label {\n  flex: 1;\n  color: #334155;\n  font-weight: 500;\n}\n\n.pie-legend-value {\n  color: #64748b;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* Детальная статистика по курсам */\n.sg-courses-detailed {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.sg-course-detailed {\n  background: white;\n  padding: 20px;\n  border-radius: 16px;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.sg-course-detailed:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);\n  border-color: #002FA7;\n}\n\n.sg-course-detailed-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.sg-course-title h5 {\n  margin: 0 0 4px 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.sg-course-subtitle {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.sg-course-coverage {\n  text-align: right;\n}\n\n.sg-course-coverage span:first-child {\n  display: block;\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.sg-coverage-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1A4FBF;\n}\n\n.sg-course-metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sg-course-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sg-course-metric span:first-child {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Адаптивность */\n@media (max-width: 1200px) {\n  .sg-filters-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n  \n  .sg-course-filter {\n    grid-column: span 1;\n  }\n  \n  .sg-specialty-filter {\n    grid-column: span 2;\n  }\n  \n  .sg-category-filter {\n    grid-column: span 2;\n  }\n  \n  .sg-group-details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .sg-groups-cards {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  }\n  \n  .sg-charts-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 1024px) {\n  .sg-controls-top-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .sg-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .sg-sort-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .sg-sort-buttons {\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n  \n  .sg-list-metrics {\n    min-width: 250px;\n  }\n  \n  .sg-key-metrics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .sg-cabinet-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .sg-header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .sg-control-panel-enhanced {\n    padding: 16px;\n  }\n  \n  .sg-filters-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .sg-specialty-filter,\n  .sg-category-filter {\n    grid-column: span 1;\n  }\n  \n  .sg-stats-cards,\n  .sg-stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .sg-section-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .sg-section-header h3 {\n    font-size: 18px;\n  }\n  \n  .sg-groups-count {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n  \n  .sg-group-card {\n    padding: 16px;\n  }\n  \n  .sg-card-main-info {\n    padding: 12px;\n    gap: 12px;\n  }\n  \n  .sg-students-value,\n  .sg-categories-value {\n    font-size: 18px;\n  }\n  \n  .sg-card-responsible {\n    gap: 8px;\n  }\n  \n  .sg-group-list-item {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n  \n  .sg-list-main {\n    order: 1;\n  }\n  \n  .sg-list-metrics {\n    order: 2;\n    min-width: 100%;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .sg-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .sg-list-details {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n  \n  .sg-sort-buttons {\n    flex-direction: column;\n  }\n  \n  .sg-view-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .pc-modal {\n    width: 90%;\n  }\n  \n  .pc-modal-header-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .pc-modal-icon {\n    align-self: flex-start;\n  }\n  \n  .sg-group-main-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .sg-group-number-card {\n    align-self: center;\n  }\n  \n  .sg-group-stats-card {\n    grid-template-columns: 1fr;\n    min-width: auto;\n  }\n  \n  .sg-stat-value {\n    font-size: 24px;\n  }\n  \n  .sg-student-main-info {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .sg-student-actions-compact {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .sg-courses-detailed {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .sg-groups-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .sg-card-group-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .sg-card-course {\n    align-self: flex-start;\n  }\n  \n  .sg-card-main-info {\n    grid-template-columns: 1fr;\n  }\n  \n  .sg-card-responsible {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .sg-view-btn span {\n    display: none;\n  }\n  \n  .sg-view-btn {\n    padding: 10px;\n    justify-content: center;\n  }\n  \n  .sg-sort-order-btn span {\n    display: none;\n  }\n  \n  .sg-sort-order-btn {\n    padding: 10px;\n    justify-content: center;\n  }\n  \n  .sg-sort-buttons {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  \n  .sg-student-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .sg-student-divider {\n    display: none;\n  }\n  \n  .sg-student-actions-compact {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .sg-toggle-details-compact {\n    width: 100%;\n  }\n  \n  .sg-filter-select-enhanced {\n    font-size: 16px;\n  }\n  \n  .pie-chart-legend {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
